module.exports = __webpack_public_path__ + "static/media/carta_45.4f6f48bc.jpg";